type ThreadPromises = Array<() => Promise<any>>;

export default function threadRequests(promises: ThreadPromises, threadsCount = 5, callback?: (_) => unknown): Promise<Array<void>> {
  const promisesSequence = promises.slice();
  const total = promises.length;
  let fulfilled = 0;
  let pending = 0;

  const callbackFunc = (res) => {
    fulfilled++;
    pending--;
    if (typeof callback === 'function') {
      callback({
        total,
        pending,
        finished: fulfilled,
        left: total - fulfilled
      });
    }
    return res;
  };

  const threads = [...Array(threadsCount).keys()];

  return Promise.all(
    threads.map(() => promisesSequence.reduce((acc) => acc
      .then((res) => {
        const request = promisesSequence.shift();
        if ((request && typeof request === 'function')) {
          pending++;
          return request().then(callbackFunc);
        }
        return res;
      }), Promise.resolve()))
  );
}
